import { Params } from '@angular/router';

export const REGISTER_ROUTE = {
  DEFAULT: '',
  name: 'register',
  PARENT: {
    name: 'parent',
    queryParams(studentId: string, classId: string): { studentId: string, classId: string } {
      return {
        classId: classId,
        studentId: studentId
      };
    },
    route(): string[] {
      return [...REGISTER_ROUTE.route(), this.name];
    }
  },
  route(): string[] {
    return ['/' + this.name];
  },
  STUDENT: {
    name: 'student',
    queryParams(state: string, redirectFromUrl = ''): Params {
      return {
        redirectfromurl: redirectFromUrl || null,
        state: state || null
      };
    },
    route(): string[] {
      return [...REGISTER_ROUTE.route(), this.name];
    }
  },
  TEACHER_PREMIUM: {
    name: 'teacherpremium',
    queryParams(code: string, schoolId: string): { code: string, schoolId: string } {
      return {
        code: code,
        schoolId: schoolId
      };
    },
    route(): string[] {
      return [...REGISTER_ROUTE.route(), this.name];
    }
  },
  TEACHER: {
    name: 'teacher',
    queryParams(email: string): { email: string } {
      return {
        email: encodeURI(email)
      };
    },
    route(): string[] {
      return [...REGISTER_ROUTE.route(), this.name];
    }
  }
}
